export const TARGET_ACTIONS = {
    TARGET_SEARCH: 'TARGET_SEARCH',
    TARGET_SEARCH_SUCCESS: 'TARGET_SEARCH_SUCCESS',
    TARGET_SEARCH_ERROR: 'TARGET_SEARCH_ERROR',

    TARGET_UPSERT: 'TARGET_UPSERT',
    TARGET_UPSERT_SUCCESS: 'TARGET_UPSERT_SUCCESS',
    TARGET_UPSERT_ERROR: 'TARGET_UPSERT_ERROR',

    TARGET_EDIT: 'TARGET_EDIT',

    TARGET_RESET: 'TARGET_RESET',
};

export const targetResetAction = () => ({
    type: TARGET_ACTIONS.TARGET_RESET,
});

export const targetSearchAction = (payload) => ({
    type: TARGET_ACTIONS.TARGET_SEARCH,
    ...payload,
});

export const targetEditAction = (payload) => ({
    type: TARGET_ACTIONS.TARGET_EDIT,
    ...payload,
});

export const targetUpsertAction = (payload) => ({
    type: TARGET_ACTIONS.TARGET_UPSERT,
    ...payload,
});

export default {
    TARGET_ACTIONS,
    targetSearchAction,
    targetUpsertAction,
    targetEditAction,
};
